import {
  Typography, Grid, Paper, Divider, Button
} from "@mui/material";

const NoServices = ({ irA }) => (
  <Paper sx={{ padding: 10 }}>
    <Grid 
      sx={{ 
        maxWidth: 820, 
        margin: "auto",
        justifyContent: "center", 
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography variant="h6" color="primary">
        Crear Servicio en One Service
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Elige cómo quieres ofrecer tus servicios en nuestra plataforma
      </Typography>
      <Grid
        container
        className="body"
        sx={{
          justifyContent: "center",
          alignItems: "stretch",
        }}
        mt={5}
      >
        <Grid size={{ xs: 12, md: 5 }}>
          <Grid 
            container 
            sx={{ 
              justifyContent: "space-between", 
              alignItems: "stretch", 
              height: "100%"
            }}
          >
            <Grid mt={{xs: 5, md:0}}>
              <Typography sx={{ textAlign: "center" }} variant="h6" color="primary">
                Servicio independiente
              </Typography>
              <Typography 
                sx={{ textAlign: "center", marginTop: 5, marginBottom: 3 }} 
                variant="body2" 
                color="text.secondary"
              >
                Ofrece un servicio individual de manera personal. Ideal para profesionales independientes con servicios específicos.
              </Typography>
              <Divider />
              <ul className="list">
                <li>
                  <Typography color="text.secondary" variant="body2">Configuración rápida</Typography>
                </li>
                <li>
                  <Typography color="text.secondary" variant="body2">Gestión directa de tu servicio</Typography>
                </li>
                <li>
                  <Typography color="text.secondary" variant="body2">Perfil personal</Typography>
                </li>
              </ul>
            </Grid>
            <Grid sx={{display: "flex", width: "100%", alignItems: "flex-end"}}>
              <Button
                onClick={() => irA("/user/crear-servicio/0")}
                variant="contained"
                size="small"
                fullWidth
                sx={{ fontSize: "14px", textTransform: "none" }}
              >
                Crear servicio individual
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid className="content-center" size={{ xs: 12, md: 2 }} mt={{xs: 5, md: 0}}>
          <Divider className="line-mobile" orientation="vertical" />
        </Grid>
        <Grid size={{ xs: 12, md: 5 }} mt={{xs: 5, md:0}}>
          <Grid container sx={{ justifyContent: "space-between", alignItems: "stretch", height: "100%"}}>
            <Grid>
              <Typography sx={{ textAlign: "center" }} variant="h6" color="primary">
                Página de servicios
              </Typography>
              <Typography 
                sx={{ textAlign: "center", marginTop: 5, marginBottom: 3 }} 
                variant="body2" 
                color="text.secondary"
              >
                Gestiona múltiples servicios en una página de manera independiente o con un grupo o negocio en donde serás administrador.
              </Typography>
              <Divider />
              <ul className="list">
                <li>
                  <Typography color="text.secondary" variant="body2">Página personalizada con banner y descripción</Typography>
                </li>
                <li>
                  <Typography color="text.secondary" variant="body2">Servicios independientes o agrupados en un negocio</Typography>
                </li>
                <li>
                  <Typography color="text.secondary" variant="body2">Administación centralizada y rol de administrador</Typography>
                </li>
                <li>
                  <Typography color="text.secondary" variant="body2">Posibilidad de invitar colaboradores</Typography>
                </li>
                <li>
                  <Typography color="text.secondary" variant="body2">Ideal para ofrecer servicios en distintas áreas</Typography>
                </li>
                <li>
                  <Typography color="text.secondary" variant="body2">Integración con redes sociales</Typography>
                </li>
              </ul>
            </Grid>
            <Grid sx={{ width: "100%", alignItems: "flex-end"}}>
              <Button
                onClick={() => irA("/user/crear-servicio/1")}
                variant="contained"
                size="small"
                fullWidth
                sx={{ fontSize: "14px", textTransform: "none", marginTop: 3 }}
              >
                Crear página de servicios
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Paper>
);

export default NoServices;